import React from 'react'
import {Oferente} from  '../models/Oferente'
interface ProductProps{
    oferente:Oferente,
}

const ComponentInscripcionLicatacion: React.FC<ProductProps> = (props)=>{
    
    return(
        <tr>
            <td>{props.oferente.name}</td>
            <td>{props.oferente.vat}</td>
        </tr>
    )
}

export default ComponentInscripcionLicatacion